/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-03-18 10:05:14
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\directive\authorizeFunction\index.js
 */
import { hasUserType } from './authorizeFunction.js'
export default {
	inserted: function(el, binding) {
		const value = binding.arg || binding.value
		if (value) {
			if (!hasUserType(value.code, value.list || [])) {
				// 移除角色权限标识控制
				// el.style.display = 'none'
			}
		}
	}
}
